import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";
import Breitscheidplatz from "@/pages/Breitscheidplatz";
import UseCasePage from "@/pages/UseCasePage";
import News from "@/pages/News";
import { USECASES } from "@/lib/usecases";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/lib/i18n";

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/en" element={<Landing />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/breitscheidplatz" element={<Breitscheidplatz />} />
          <Route path="/aktuelles" element={<News />} />
          <Route path="/en/news" element={<News />} />
          {USECASES.map((u) => (
            <Route key={u.deSlug} path={`/${u.deSlug}`} element={<UseCasePage uc={u} />} />
          ))}
          {USECASES.map((u) => (
            <Route key={u.enSlug} path={`/en/${u.enSlug}`} element={<UseCasePage uc={u} />} />
          ))}
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-center" />
    </LanguageProvider>
  );
}

export default App;
